import React from 'react';
import { Routes, Route } from "react-router-dom";
import Privacy from "./components/Privacy";
import Footer from './components/Footer';
import Header from './components/Header';
import TranscriptionPage from "./components/TranscriptionPage"; // we’ll extract this
import Contact from "./components/Contact";
import About from "./components/About";
import SignIn from './components/SignIn';
import Terms from "./components/Terms";
import TTSPage from "./components/TTSPage";

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-sky-100">
      <Header />
      
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<TranscriptionPage />} />
		  <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
		  <Route path="/contact" element={<Contact />} />
		  <Route path="/signin" element={<SignIn />} />
		  <Route path="/terms" element={<Terms />} />
		  <Route path="/ttspage" element={<TTSPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
